import _ from 'lodash';
import sitePreset from './modulePresets/site';
import embedPreset from './modulePresets/embed';

export default class {
  constructor(config) {
    this.config = config;

    config.supportedDrmType = this.checkDrm();
  }

  initModules(type = 'site') {
    if (type === 'site') {
      const isMobile = Boolean(this.config.userAgent.device.type);
      const isCMS = this.config.skin === 'default3';
      this.modules = sitePreset(this.config, { isMobile, isCMS });
    } else if (type === 'embed') {
      this.modules = embedPreset(this.config);
    }
  }

  needDashLib() {
    return (
      Boolean(_.find(this.modules, { name: 'vendorDash' })) && !window.shaka
    );
  }

  needChromecastScript() {
    const {
      userAgent: { browser },
    } = this.config;
    return (
      _.get(browser, 'name', '').indexOf('Chrome') !== -1 &&
      !_.get(window, 'chrome.cast')
    );
  }

  needPahoLib() {
    return Boolean(_.find(this.modules, { name: 'pluginMns' }));
  }

  getModules() {
    return _.map(this.modules, 'module');
  }

  checkHLSJS() {
    let result = false;
    try {
      result =
        window.MediaSource &&
        typeof window.MediaSource.isTypeSupported === 'function' &&
        window.MediaSource.isTypeSupported(
          "video/mp4; codecs='avc1.42E01E,mp4a.40.2'"
        );
    } catch {
      result = false;
    }

    return result;
  }

  checkDrm() {
    const device = _.get(this.config, 'userAgent.device', {});
    const browser = _.get(this.config, 'userAgent.browser', {});
    const os = _.get(this.config, 'userAgent.os', {});
    const browserVersion = parseFloat(browser.version);
    let supportedDrmType = '';

    // info about drm https://drmtoday.com/platforms/ table 'HTML5 Browsers'
    if (browser.name === 'Edge') {
      supportedDrmType = 'playready';
    } else if (browser.name === 'IE' && browserVersion >= 11) {
      supportedDrmType = 'playready';
    } else if (browser.name === 'Safari' && browserVersion >= 8) {
      supportedDrmType = 'fairplay';
    } else if (browser.name === 'Chrome' && browserVersion >= 35) {
      supportedDrmType = 'modular';
    } else if (
      browser.name === 'Firefox' &&
      browserVersion >= 47 &&
      os.name !== 'Linux'
    ) {
      supportedDrmType = 'modular';
    } else if (browser.name === 'Opera' && browserVersion >= 31) {
      supportedDrmType = 'modular';
    } else {
      supportedDrmType = 'modular'; // Yandex, Vivaldi, ...etc
    }

    if (device.type === 'mobile' || device.type === 'tablet') {
      if (device.vendor === 'Apple') {
        supportedDrmType = 'fairplay';
      } else {
        supportedDrmType = 'modular';
      }
    }

    return supportedDrmType;
  }
}
